import React from 'react'
import { Helmet } from 'react-helmet';
import '../css/fitness.css';
/* Import the image to be shown on the page */
import schedule4 from '../images/Summer-Dance-Camp-2026.png';
import button from '../images/button_enroll-now.png';

export default function Summer() {
    return (
        <div className="fitness-content">
            <Helmet>
                <title>In Motion Dance | Summer</title>
            </Helmet>
            <h1> In Motion Dance Studio<br/> Summer Dance Camp - 2026 </h1>
            <h3>Published/Updated: Tuesday, July 7th, 2026 </h3><br/>
            <img src={schedule4} alt='Summer-Dance-Camp-2026'/> 
            <br/><br/>
                <a href='enroll'>
                <img src={button} alt='Enroll Now'/>
                </a>
            <br/><br/>       
        </div>
    )
}